import { Page } from '@app/components';
import type { NPage } from '@app/components/Page/types/Page.main';
import {
  CLIENTS,
  CLIENTS_LABEL,
  CLIENTS_PATH,
  RIGHTS_CLIENTS,
} from '@app/constants';
import { DublicateClients, DublicateClientsSettings } from '@app/pages';
import {
  DUBLICATE_CLIENTS,
  DUBLICATE_CLIENTS_LABEL,
  DUBLICATE_CLIENTS_PATH,
  DUBLICATE_CLIENTS_SETTINGS,
  DUBLICATE_CLIENTS_SETTINGS_LABEL,
  DUBLICATE_CLIENTS_SETTINGS_PATH,
} from '@app/routes/pages/duplicateClientsPages/constants';
import type { NNavigation } from '@app/types';

const clientsLevelData: NPage.LevelDataModel = {
  title: CLIENTS_LABEL,
  path: CLIENTS_PATH,
};

const duplicateClientsLevelData: NPage.LevelDataModel = {
  title: DUBLICATE_CLIENTS_LABEL,
  path: DUBLICATE_CLIENTS_PATH,
};

export const duplicateClientsPages: NNavigation.Main = [
  {
    key: DUBLICATE_CLIENTS,
    label: DUBLICATE_CLIENTS_LABEL,
    id: DUBLICATE_CLIENTS,
    path: DUBLICATE_CLIENTS_PATH,
    element: (
      <Page
        secondLevelData={clientsLevelData}
        headerContent={<DublicateClients.Header />}
      >
        <DublicateClients.Page />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CLIENTS,
    sidebarparentid: CLIENTS,
  },
  {
    key: DUBLICATE_CLIENTS_SETTINGS,
    label: DUBLICATE_CLIENTS_SETTINGS_LABEL,
    id: DUBLICATE_CLIENTS_SETTINGS,
    path: DUBLICATE_CLIENTS_SETTINGS_PATH,
    element: (
      <Page
        secondLevelData={clientsLevelData}
        thirdLevelData={duplicateClientsLevelData}
      >
        <DublicateClientsSettings.Page />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CLIENTS,
    sidebarparentid: CLIENTS,
  },
];
